const MENU_ONE_DATA_CHILD_1 = [
    { title: 'Scavenger hunt' },
    { title: 'Game' },
    { title: 'Other' },
];

const MENU_ONE_DATA_CHILD_2 = [
    { title: 'Auto' },
    { title: 'Grocery' },
    { title: 'Fashion' },
    { title: 'Textile' },
    { title: 'Food' },
    { title: 'Other' }
];
const MENU_ONE_DATA_CHILD_3 =  [
    { title: 'school' },
    { title: 'university' },
    { title: 'project' },
    { title: 'yearbook' },
    { title: 'Other' }
];
const MENU_ONE_DATA_CHILD_4 = [
    { title: 'museul' },
    { title: 'guided tours' },
    { title: 'Project' },
    { title: 'Yearbook' },
    { title: 'Other' }
];

const Content = {
    MENU_ONE_DATA: [
        { title: 'Entertainment', child: MENU_ONE_DATA_CHILD_1 },
        { title: 'Print or Poster' },
        { title: 'Social Media distribution' },
        { title: 'CPG (Packaging)' },
        { title: 'Retail Offline', child: MENU_ONE_DATA_CHILD_2},
        { title: 'Retail e-commerce', child: MENU_ONE_DATA_CHILD_2 },
        { title: 'Digital or banner Ads' },
        { title: 'Marketing' },
        { title: 'Education' },
        { title: 'Places of Interest', child: MENU_ONE_DATA_CHILD_3 },
        { title: 'Training or Event', child: MENU_ONE_DATA_CHILD_4 },
        { title: 'Other' },
    ],
    MENU_TWO_DATA: [
        { title: 'I want AR without app download' },
        { title: 'I want to use ROAR app' },
        { title: 'I want to use my existing app' },
        { title: 'I want to build whitelabel' },
    ],
    MENU_THREE_DATA: [
        { title: 'I point to label or object and scan it' },
        { title: 'I point to space where I want to fit my item' },
        { title: 'I point to and scan QR code' },
        { title: 'I can AR stream content to others' },
        { title: 'At specific geo-location' },
        { title: 'Digital ad AR icon is clicked ' },
        { title: 'Website AR icon is clicked ' },
    ]
}

export default Content